import { Component, OnInit } from '@angular/core';
import { InterfacesService } from '../interfaces.service';
import { UntypedFormControl } from '@angular/forms';

@Component({
  selector: 'app-interfaz-clientes',
  templateUrl: './interfaz-clientes.component.html',
  styleUrls: ['./interfaz-clientes.component.scss']
})
export class InterfaceClientesComponent implements OnInit {
  interfaces;
  interfacesFiltradas;
  interfazSeleccionada;
  buscadorFormControl = new UntypedFormControl();

  constructor(public interfacesService: InterfacesService) {}

  

  ngOnInit(): void {
    this.obtenerInterfaces();
  }

  obtenerInterfaces() {
    this.interfaces = this.interfacesService.obtenerInterfazClientes();
    this.interfacesFiltradas = this.interfaces;
  }

  filtrarInterfaces() {
    this.interfacesFiltradas = this.interfaces.filter(i => i.nombre.toLowerCase().includes(this.buscador.value.toLowerCase()));
  }

  mostrarInterfaz(event) {
    this.interfazSeleccionada = event;
  }

  get buscador() {
    return this.buscadorFormControl;
  }
}
